const COMMENTS_SECTION_KEY = '17842412559e67a640';

function findCommentsSection() {
  return document.querySelector(
    `[id="shopify-section-${COMMENTS_SECTION_KEY}"], [id$="__${COMMENTS_SECTION_KEY}"]`
  );
}

function findReviewerName(card) {
  return card.querySelector(
    '[class*="reviewer-name"], [class*="reviewer_name"], [class*="author-name"], [class*="author_name"], [class*="reviewer"] [class*="name"]'
  );
}

function findCard(image, carousel) {
  let element = image.parentElement;
  while (element && element !== carousel) {
    if (findReviewerName(element)) return element;
    element = element.parentElement;
  }
  return null;
}

function findMediaWrapper(image, card) {
  const candidates = [
    image.closest('picture'),
    image.closest('[class*="review-media"]'),
    image.closest('[class*="review_media"]'),
    image.closest('[class*="card-media"]'),
    image.closest('[class*="card_media"]'),
    image.closest('[class*="image-wrapper"]'),
    image.closest('[class*="image_wrapper"]'),
    image.closest('a'),
  ];

  return candidates.find((candidate) => candidate && candidate !== card && card.contains(candidate)) || image;
}

function arrangeComments() {
  const section = findCommentsSection();
  const carousel = section?.querySelector('.jdgm-cards-carousel');
  if (!carousel) return;

  carousel.querySelectorAll('img').forEach((image) => {
    if (image.closest('.jdgm-star, [class*="rating"], [class*="badge"], [class*="logo"]')) return;

    const card = findCard(image, carousel);
    const reviewerName = card && findReviewerName(card);
    if (!card || !reviewerName) return;

    const media = findMediaWrapper(image, card);
    const reviewerRow = reviewerName.parentElement || reviewerName;
    if (media.dataset.vitavaReviewerAvatar === 'true') return;

    media.dataset.vitavaReviewerAvatar = 'true';
    media.classList.add('vitava-reviewer-avatar');
    image.classList.add('vitava-reviewer-avatar__image');
    reviewerRow.classList.add('vitava-reviewer-row');
    reviewerRow.append(media);
  });
}

const observer = new MutationObserver(arrangeComments);

function initializeCommentsLayout() {
  const section = findCommentsSection();
  if (!section) return;
  arrangeComments();
  observer.disconnect();
  observer.observe(section, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCommentsLayout, { once: true });
} else {
  initializeCommentsLayout();
}

document.addEventListener('shopify:section:load', initializeCommentsLayout);
